import styled from 'styled-components';
import { Icon } from 'hype-ds';

export const TrashIcon = styled(Icon)`
	color: var(--text-link);
`;
